<script setup lang="ts">
import { ref } from 'vue';
import axios from 'axios';

// ================= 1. 定义 Props 的 TypeScript 接口 =================
// 根据模板和方法推断出 obj 的数据结构
interface ItemData {
  guid: string;
  link: string;
  icon: string;
  title: string;
  hit: number;
  rate: number;
  image?: string; // handleShow 方法中用到了 image
}

const props = defineProps<{
  obj: ItemData;
}>();

// ================= 2. 获取全局变量 =================
// 直接使用环境变量，避免 getCurrentInstance 在生产环境的问题
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8003';

// ================= 3. 响应式状态 (替代 data) =================
const isHited = ref<boolean>(false);
// const isRated = ref<boolean>(false);
// hitres 初始为字符串，但在 axios 回调中会被赋值为 response 对象，所以用 any
const hitres = ref<any>(""); 

// ================= 4. 方法 (替代 methods) =================

// 注意：当前模板中没有 el-popover，此方法暂时不会被触发
// const handleShow = (e: ItemData) => {
//   console.log('@/assets/' + e.image);
//   // 原代码中有 this.$refs 操作，但当前模板中没有对应的 ref，故省略
// };

const hit = (guid: string, url: string) => {
  window.open(url, "_blank");

  if (!isHited.value) {
    // 修改 prop 对象的内部属性在 Vue3 中是允许的
    props.obj.hit += 1;
    isHited.value = true;
    
    // http get 通知 php，修改数据库
    axios
      .get(apiBaseUrl + '/api/update_hit_rate/hit/' + guid)
      .then(response => (hitres.value = response))
      .catch(error => {
        console.log(error);
      });
      // 10% 概率触发同步 JSON
        if (Math.random() < 1) {
            syncHitRateJson();
        }
  }
};

// 注意：当前模板中没有绑定此方法，保留以备后续使用
// const rate = (guid: string) => {
//   if (!isRated.value) {
//     props.obj.rate += 1;
//     isRated.value = true;
    
//     // http get 通知 php，修改数据库
//     axios
//       .get(apiBaseUrl + '/api/update_hit_rate/rate/' + guid)
//       .then(response => (hitres.value = response))
//       .catch(error => {
//         console.log(error);
//       });
//       // 10% 概率触发同步 JSON
//       if (Math.random() < 1) {
//           syncHitRateJson();
//       }
//   }
// };

// 同步 hit 和 rate 到 JSON 文件
const syncHitRateJson = () => {
    axios
        .get(apiBaseUrl + '/api/update_hit_rate_json')
        .then(response => {
            console.log('JSON synced:', response.data);
        })
        .catch(function (error) {
            console.log('Sync JSON failed:', error);
        });
};


</script>

<template>
  <el-col :span="3">
    <el-card class="card" shadow="hover" :body-style="{ padding: '0' }">
      <div class="small-icon-title" @click="hit(obj.guid, obj.link)">
        <img :src="'icons/' + obj.icon" alt="图" />
        <span class="small-title-span">{{ obj.title }}</span>
      </div>
    </el-card>
  </el-col>
</template>

<style lang="scss">
.card {
  margin-top: 10px;
  margin-bottom: 10px;

  .small-icon-title {
    padding: 10px 8% 10px 8%;
    border-radius: 10px;
    text-decoration: none;
    height: 26px;
    cursor: pointer;

    img {
      float: left;
      width: 26px;
      height: 26px;
    }

    .small-title-span {
      color: #3c3c3c;
      font-size: 14px;
      line-height: 30px;
      overflow: hidden;
      margin-left: 10px;
      float: right;
    }
  }
}
</style>